import clsx from "clsx";

export const DialogBody: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = ({ children, className }) => {
  return (
    <div className={clsx("grow overflow-auto p-6 max-sm:px-4", className)}>
      {children}
    </div>
  );
};
